import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { Check, Circle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
// The structural rules of lib/password-policy.ts (validatePassword), shown as
// a live checklist so each rule is visible up front instead of arriving one
// rejected submit at a time. validatePassword stays the gate (it also refuses
// common passwords); PasswordPolicyHint.test pins this list to it.
const MIN_LENGTH = 12;
const RULES = [
    { key: 'password.rule.minLength', test: (p) => p.length >= MIN_LENGTH },
    { key: 'password.rule.uppercase', test: (p) => /[A-Z]/.test(p) },
    { key: 'password.rule.lowercase', test: (p) => /[a-z]/.test(p) },
    { key: 'password.rule.digit', test: (p) => /\d/.test(p) },
];
/**
 * Live policy checklist under a new-password field. Renders nothing until the
 * user starts typing, so the form stays compact on a phone; the field's
 * placeholder carries the headline rule until then.
 */
export function PasswordPolicyHint({ id, password }) {
    const { t } = useTranslation();
    if (!password)
        return null;
    return (_jsx("ul", { id: id, className: "grid grid-cols-2 gap-x-3 gap-y-1 text-xs", "aria-label": t('password.rulesLabel'), "data-testid": id, children: RULES.map((rule) => {
            const met = rule.test(password);
            return (_jsxs("li", { className: cn('flex items-center gap-1.5', met ? 'text-primary' : 'text-muted-foreground'), "data-met": met, children: [met ? (_jsx(Check, { className: "h-3.5 w-3.5 shrink-0", "aria-hidden": true })) : (_jsx(Circle, { className: "h-3 w-3 shrink-0", "aria-hidden": true })), _jsx("span", { children: t(rule.key, { min: MIN_LENGTH }) }), _jsx("span", { className: "sr-only", children: met ? t('password.ruleMet') : t('password.ruleNotMet') })] }, rule.key));
        }) }));
}
